import { render } from "./HistoriesView.vue?vue&type=template&id=31d142fc&scoped=true&ts=true"
import script from "./HistoriesView.vue?vue&type=script&lang=ts"
export * from "./HistoriesView.vue?vue&type=script&lang=ts"

import "./HistoriesView.vue?vue&type=style&index=0&id=31d142fc&scoped=true&lang=css"

import exportComponent from "/Users/kosugi/Dev/IdeaProjects/v4/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d142fc"]])

export default __exports__